// API target
// CRA inlines this at build time; no runtime `process` access is required.
const ENV_API_BASE = process.env.REACT_APP_API_URL as string | undefined;
export const API_BASE: string = ENV_API_BASE || '';

// Optional: Cloudflare Analytics link
const ENV_CF_ANALYTICS = process.env.REACT_APP_CLOUDFLARE_ANALYTICS_URL as string | undefined;
export const CF_ANALYTICS_URL: string = ENV_CF_ANALYTICS || 'https://dash.cloudflare.com/web-analytics';
